import React from 'react';

type Props = {};

function CalendarDayTitles({}: Props) {
  return (
    <div className="medispa-calendar_days-titles">
      <p>Sun</p>
      <p>Mon</p>
      <p>Tue</p>
      <p>Wed</p>
      <p>Thu</p>
      <p>Fri</p>
      <p>Sat</p>
    </div>
  );
}

export default CalendarDayTitles;
